import {
  add,
  differenceInCalendarDays,
  Duration,
  isEqual,
  isToday,
  sub,
} from 'date-fns';
import { DateRange } from 'react-day-picker';

export abstract class DateUtility {
  static today(): Date {
    return new Date();
  }
  static firstDayOfYear(): Date {
    return new Date(new Date().getFullYear(), 0, 1);
  }
  static subtract(date: Date, duraction: Duration): Date {
    return sub(date, duraction);
  }
  static isToday(date: Date): boolean {
    return isToday(date);
  }

  static differenceInDays(to: Date, from: Date): number {
    return differenceInCalendarDays(to, from);
  }

  static isBetween(date: Date, startDate: Date, endDate: Date): boolean {
    return startDate <= date && date <= endDate;
  }

  static isBefore(date: Date, dateToCompare: Date): boolean {
    return this.differenceInDays(date, dateToCompare) <= 0;
  }

  static addDays(date: Date, days: number): Date {
    return add(date, { days });
  }

  static formatDate(
    date: Date,
    locale: string,
    options?: {
      dayFormat?: 'numeric' | '2-digit';
      monthFormat?: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow';
      yearFormat?: 'numeric' | '2-digit';
      hourFormat?: 'numeric' | '2-digit';
      minuteFormat?: 'numeric' | '2-digit';
      hour12?: boolean;
    },
  ): string {
    return new Intl.DateTimeFormat(locale, {
      day: options?.dayFormat ?? '2-digit',
      month: options?.monthFormat ?? 'short',
      year: options?.yearFormat ?? '2-digit',
      hour: options?.hourFormat,
      minute: options?.minuteFormat,
      hour12: options?.hour12,
    }).format(date);
  }

  static extractDateStringQueryParamsFromRange(dateRange?: DateRange): {
    fromDate?: string;
    toDate?: string;
  } {
    return {
      fromDate:
        !!dateRange?.from &&
        !!dateRange?.to &&
        !isEqual(dateRange.from, dateRange.to)
          ? dateRange.from.toISOString()
          : undefined,
      toDate: dateRange?.to && dateRange.to.toISOString(),
    };
  }
}
